export default "__VITE_ASSET__DVhH0PB4__"